var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"title":_vm.message,"type":"error","closable":false}})}
var staticRenderFns = []

export { render, staticRenderFns }